import { render, staticRenderFns } from "./selectchoice.vue?vue&type=template&id=04355506&scoped=true&"
import script from "./selectchoice.vue?vue&type=script&lang=js&"
export * from "./selectchoice.vue?vue&type=script&lang=js&"
import style0 from "./selectchoice.vue?vue&type=style&index=0&id=04355506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04355506",
  null
  
)

export default component.exports